import { applyDefaultChildrenIfNoChildren } from '@/components/combined-predict/components/CombinedPredictTable/utils/mappedGroupBuilders'
import { getEpiSuiteModelDescription } from '@/components/combined-predict/models/epiSuite/epiSuiteMetadata'
import { joinWithBr } from '@/utils/html'

const KEY_PROPERTY_SEPARATOR = '-'

const epiSuiteColumnGroups = [
  {
    id: 'detail',
    name: '',
    hideInSelect: true,
    children: null,
  },

  {
    id: 'logKow',
    name: 'Log K<sub>ow</sub>',
    unit: 'Log10 unitless',
    helpPage: 'kowwin',
  },
  {
    id: 'meltingPoint',
    name: 'Melting Point',
    shortTitle: 'MP',
    unit: '°C',
    helpPage: 'mpbpvp',
  },
  {
    id: 'boilingPoint',
    name: 'Boiling Point',
    shortTitle: 'BP',
    unit: '°C',
    helpPage: 'mpbpvp',
  },
  {
    id: 'waterSolubilityFromLogKow',
    name: 'WSKOWWIN',
    shortTitle: 'WS Kow',
    description: 'Water Solubility WSKOWWIN',
    unit: 'mg/L',
    helpPage: 'wskowwin',
  },
  {
    id: 'waterSolubilityFromWaterNt',
    name: 'WaterNT',
    description: 'Water Solubility WaterNT',
    unit: 'mg/L',
    helpPage: 'waternt',
  },
  {
    id: 'vaporPressure',
    name: 'Vapor Pressure',
    shortTitle: 'VP',
    unit: 'mmHg',
    helpPage: 'mpbpvp',
  },
  {
    id: 'henrysLawConstant',
    name: "Henry's Law Constant",
    shortTitle: 'HLC',
    unit: 'atm-m3/mol',
    helpPage: 'henrywin',
  },

  {
    id: 'logKoa',
    name: 'Log K<sub>OA</sub>',
    unit: 'Log10 unitless',
    helpPage: 'koawin',
  },

  {
    id: 'biodegradationRate',
    name: 'Biowin',
    shortTitle: 'Biowin',
    helpPage: 'biowin',
    children: [
      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}linearModelPrediction`,
        name: 'Linear Model Prediction',
        hideInSelect: true,
      },
      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}nonLinearModelPrediction`,
        name: 'Non-Linear Model Prediction',
        hideInSelect: true,
      },
      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}ultimateBiodegradationTimeframe`,
        name: 'Ultimate Biodegradation Timeframe',
        hideInSelect: true,
      },
      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}primaryBiodegradationTimeframe`,
        name: 'Primary Biodegradation Timeframe',
        hideInSelect: true,
      },
      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}mitiLinearModelPrediction`,
        name: 'MITI Linear Model Prediction',
        hideInSelect: true,
      },
      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}mitiNonLinearModelPrediction`,
        name: 'MITI Non-Linear Model Prediction',
        hideInSelect: true,
      },
      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}anaerobicModelPrediction`,
        name: 'Anaerobic Model Prediction',
        hideInSelect: true,
      },
      // {
      //   id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}nonLinearModelPrediction`,
      //   name: 'Readily Biodegradable?',
      // },
    ],
  },

  {
    id: 'hydrocarbonBiodegradationRate',
    name: 'Hydrocarbon Biodegradation Half-life',
    unit: 'days',
    shortTitle: 'BioHCwin',
    helpPage: 'biohcwin',
    children: [
      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}halfLifeDays`,
        name: 'Half-life',
        unit: 'days',
        hideInSelect: true,
      },
    ],
  },

  {
    id: 'logKoc',
    name: 'Log K<sub>OC</sub>',
    description: 'Organic Carbon Partition Coefficient',
    unit: 'Log10 L/kg',
    helpPage: 'kocwin',
  },
  {
    id: 'atmosphericHalfLife',
    name: 'Atmospheric Half-Life',
    unit: 'hours',
    helpPage: 'aopwin',
  },

  {
    id: `bioconcentration`,
    name: 'Bioconcentration',
    helpPage: 'bcfbaf',
    children: [
      {
        id: 'bioconcentrationFactor',
        name: 'Bioconcentration Factor',
        description: 'Regression-based estimate',
        unit: 'L/kg',
        hideInSelect: true,
      },
      {
        id: 'biotransformationHalfLife',
        name: 'Biotransformation Half-Life',
        description: 'Normalized to 10 g fish',
        unit: 'days',
        hideInSelect: true,
      },
      {
        id: 'bioaccumulationFactor',
        name: 'Bioaccumulation Factor',
        description: 'Arnot-Gobas upper trophic estimate',
        unit: 'L/kg',
        hideInSelect: true,
      },
    ],
  },

  // {
  //   id: `bioconcentration${KEY_PROPERTY_SEPARATOR}bioconcentrationFactor`,
  //   name: 'Bioconcentration Factor',
  //   helpPage: 'bcfbaf',
  //   unit: 'L/kg',
  //   //SHOULD BE DEFAULT
  //   // children: [
  //   //   {
  //   //     id: 'bioconcentrationFactor',
  //   //     name: 'Bioconcentration Factor',
  //   //     description: 'Regression-based estimate',
  //   //   },
  //   //   {
  //   //     id: 'biotransformationHalfLife',
  //   //     name: 'Biotransformation Half-Life',
  //   //     description: 'Normalized to 10 g fish',
  //   //     unit: 'days',
  //   //   },
  //   // ],
  // },

  {
    id: 'waterVolatilization',
    name: 'Volatilization',
    unit: 'hours',
    helpPage: 'wvolwin',
    children: [
      {
        id: `riverHalfLifeHours`,
        name: 'River',
        hideInSelect: true,
      },
      {
        id: `lakeHalfLifeHours`,
        name: 'Lake',
        hideInSelect: true,
      },
    ],
  },

  {
    id: 'hydrolysis',
    name: 'HYDROWIN',
    unit: 'days',
    helpPage: 'hydrowin',
    children: [
      {
        id: `halfLives${KEY_PROPERTY_SEPARATOR}7.0`,
        name: 'Est. at pH7',
        description: 'Est. Base-catalyzed Half-life at pH7',
        hideInSelect: true,
      },
      {
        id: `halfLives${KEY_PROPERTY_SEPARATOR}8.0`,
        name: 'Est. at pH8',
        description: 'Est. Base-catalyzed Half-life at pH8',
        hideInSelect: true,
      },
    ],
  },

  {
    id: 'dermalPermeability',
    name: 'Dermal',
    helpPage: 'dermwin',
    children: [
      {
        id: `dermalAbsorbedDosePerEvent`,
        name: 'Absorption per Event',
        unit: 'mg/cm2-event',
        hideInSelect: true,
      },
      {
        id: `dermalAbsorbedDose`,
        name: 'Absorbed Dose',
        unit: 'mg/kg-day',
        hideInSelect: true,
      },
    ],
  },

  {
    id: 'aerosolAdsorptionFraction',
    name: 'AERO',
    helpPage: 'aerowin',
    children: [
      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}jungePankowAdsorptionFraction`,
        name: 'Junge-Pankow Model',
        description: 'Junge-Pankow Adsorption Model',
        hideInSelect: true,
      },

      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}koaAdsorptionFraction`,
        name: 'K<sub>OA</sub> Model',
        description: 'Octanol-Air Partition Coefficient Model',
        coefficientKey: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}koaParticleGasPartitionCoefficient`,
        hideInSelect: true,
      },

      {
        id: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}mackayAdsorptionFraction`,
        name: 'Mackay Model',
        description: 'Mackay Adsorption Model',
        coefficientKey: `predicted${KEY_PROPERTY_SEPARATOR}model${KEY_PROPERTY_SEPARATOR}mackayParticleGasPartitionCoefficient`,
        hideInSelect: true,
      },
    ],
  },

  {
    id: 'sewageTreatmentModel',
    name: 'STPWIN',
    helpPage: 'stpwin',
    children: [
      {
        id: `model${KEY_PROPERTY_SEPARATOR}TotalAir${KEY_PROPERTY_SEPARATOR}Percent`,
        name: 'Air',
        unit: '%',
        hideInSelect: true,
      },
      {
        id: `model${KEY_PROPERTY_SEPARATOR}TotalSludge${KEY_PROPERTY_SEPARATOR}Percent`,
        name: 'Sludge',
        unit: '%',
        hideInSelect: true,
      },
      {
        id: `model${KEY_PROPERTY_SEPARATOR}TotalBiodeg${KEY_PROPERTY_SEPARATOR}Percent`,
        name: 'Biodegradation',
        unit: '%',
        hideInSelect: true,
      },
      {
        id: `model${KEY_PROPERTY_SEPARATOR}FinalEffluent${KEY_PROPERTY_SEPARATOR}Percent`,
        name: 'Effluent',
        unit: '%',
        hideInSelect: true,
      },
    ],
  },

  {
    id: 'fugacityModel',
    name: 'Fugacity',
    helpPage: 'fugacity',
    children: [
      {
        id: `model${KEY_PROPERTY_SEPARATOR}Air${KEY_PROPERTY_SEPARATOR}MassAmount`,
        name: 'Air',
        unit: '%',
        hideInSelect: true,
      },
      {
        id: `model${KEY_PROPERTY_SEPARATOR}Water${KEY_PROPERTY_SEPARATOR}MassAmount`,
        name: 'Water',
        unit: '%',
        hideInSelect: true,
      },
      {
        id: `model${KEY_PROPERTY_SEPARATOR}Soil${KEY_PROPERTY_SEPARATOR}MassAmount`,
        name: 'Soil',
        unit: '%',
        hideInSelect: true,
      },
      {
        id: `model${KEY_PROPERTY_SEPARATOR}Sediment${KEY_PROPERTY_SEPARATOR}MassAmount`,
        name: 'Sediment',
        unit: '%',
        hideInSelect: true,
      },
    ],
  },

  {
    id: 'ecosar',
    name: 'ECOSAR',
    helpPage: 'ecosar',
    unit: 'mg/L',

    children: [
      {
        id: `modelResults${KEY_PROPERTY_SEPARATOR}Neutral Organics${KEY_PROPERTY_SEPARATOR}LC50${KEY_PROPERTY_SEPARATOR}Fish`,
        name: 'Fish (96 hr)',
        description: 'Neutral Organics, LC50 for Fish (96 hr)',
        hideInSelect: true,
      },
      {
        id: `modelResults${KEY_PROPERTY_SEPARATOR}Neutral Organics${KEY_PROPERTY_SEPARATOR}LC50${KEY_PROPERTY_SEPARATOR}Daphnid`,
        name: 'Daphnid (48 hr)',
        description: 'Neutral Organics, LC50 for Daphnid (48 hr)',
        hideInSelect: true,
      },
      {
        id: `modelResults${KEY_PROPERTY_SEPARATOR}Neutral Organics${KEY_PROPERTY_SEPARATOR}LC50${KEY_PROPERTY_SEPARATOR}Fish (SW)`,
        name: 'Fish (SW, 96 hr)',
        description: 'Neutral Organics, LC50 for Fish (SW, 96 hr)',
        hideInSelect: true,
      },
      {
        id: `modelResults${KEY_PROPERTY_SEPARATOR}Neutral Organics${KEY_PROPERTY_SEPARATOR}LC50${KEY_PROPERTY_SEPARATOR}Mysid`,
        name: 'Mysid (96 hr)',
        description: 'Neutral Organics, LC50 for Mysid (96 hr)',
        hideInSelect: true,
      },
      {
        id: `modelResults${KEY_PROPERTY_SEPARATOR}Neutral Organics${KEY_PROPERTY_SEPARATOR}LC50${KEY_PROPERTY_SEPARATOR}Earthworm`,
        name: 'Earthworm (14 day)',
        description: 'Neutral Organics, LC50 for Earthworm (14 day)',
        hideInSelect: true,
      },
    ],
  },
]

const applyDescriptionFromMetadata = (group) => {
  if (!group) return null
  const descriptionFromMetadata = getEpiSuiteModelDescription(group.id)
  const description = joinWithBr([group.description, descriptionFromMetadata])
  return { ...group, description }
}

const getEnrichedWithMetadataColumnGroups = () => epiSuiteColumnGroups.map(applyDescriptionFromMetadata)

const findEpiSuiteGroupById = (id) =>
  applyDescriptionFromMetadata(epiSuiteColumnGroups.find((group) => group.id === id))

const getEpiSuiteColumnGroups = () => getEnrichedWithMetadataColumnGroups().map(applyDefaultChildrenIfNoChildren)

export { KEY_PROPERTY_SEPARATOR, epiSuiteColumnGroups, getEpiSuiteColumnGroups, findEpiSuiteGroupById }
